/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './ExpressionWatcher';
import { helpRenders } from './ExpressionWatcher_Help';

const ExpressionWatcherManager: ComponentManagerFn<'ExpressionWatcher'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'ExpressionWatcher'>(platform, 'ExpressionWatcher'),
    type: 'ExpressionWatcher',
    name: 'Expression Watcher',
    defaultValue,
    props: {
      enabledCondition: {
        label: 'Enabled Condition',
        type: 'expressionOnly',
        returnType: () => 'boolean',
      },
      expressionToWatch: {
        label: 'Expression To Watch',
        type: 'expressionOnly',
        returnType: () => 'any',
        required: true,
      },
    },
    getDisplayText: (item) => item.props.expressionToWatch,
    category: 'Others',
    noOverlay: true,
    icon: { iconName: 'search-dollar' },
    description: `Expression Watcher is used to watching for any changes to the given expression's output. 
And when there is a change, \`Trigger On Change\` will be fired on any associated \`Expression Watch Listener\` rendered on the page. This will be in action only when enabled condition resolves to true.

For example, if you have a page level filter & multiple charts across different tabs that depends on the filter.
You can use \`Expression Watcher\` to watch for any changes to the filter and have multiple \`Expression Watch Listener\` with unique group key for each data store to update the charts accordingly.
This way you can only refresh the charts that are visible to the user and not the onces that are not visible.

Without \`Expression Watcher\`, you will have to refresh all the charts on the page (even the onces that are not visible to the user) when the filter changes which is not ideal.
`,
    helpRenders,
  };
};

export default ExpressionWatcherManager;
